export enum OrigemMovimentacaoEnum {
  InicioEstoque = 1,
  NotaFiscalEntrada = 2,
  NFeSaida = 3,
  NFCeSaida = 4,
  OrdemProducao = 5,
  MovimentacaoManual = 6,
  Inventario = 7,
  TrocaMercadoria = 8,
  PedidoVenda = 9,
  Transferencia = 10,
  // 11 (Estorno) e 12 (Exclusão) foram aposentados: a exclusão de movimentação manual
  // passou a ser física, sem contramovimento.
  PedidoCompra = 13,
}
